export default __webpack_public_path__ + "static/media/werewolves-killed.2f0b9e46.mp3";